<template>
  <div class="feedback-bar">
    <template v-if="state === 'idle'">
      <span class="fb-label">这个回答对您有帮助吗？</span>
      <button class="fb-btn" @click="like">有用</button>
      <button class="fb-btn" @click="state = 'dislike'">没用</button>
    </template>
    <template v-else-if="state === 'dislike'">
      <div class="fb-reasons">
        <button
          v-for="r in reasons"
          :key="r"
          type="button"
          class="fb-reason"
          :class="{ sel: selectedReason === r }"
          @click="selectedReason = r"
        >{{ r }}</button>
      </div>
      <div class="fb-input-wrap">
        <input v-model="text" class="fb-input" placeholder="可补充具体问题或建议（选填）..." @keydown.enter.prevent="submit" />
        <button class="fb-submit" @click="submit">提交反馈</button>
        <button class="fb-skip" @click="skip">跳过</button>
      </div>
    </template>
    <span v-else class="fb-done">{{ doneText }}</span>
  </div>
</template>

<script>
import { feedbackApi } from '@/api'

export default {
  name: 'FeedbackBar',
  props: {
    question: { type: String, required: true },
    askRecordId: { type: [Number, String], default: null },
    conversationId: { type: String, default: '' }
  },
  data() {
    return {
      state: 'idle',
      reasons: ['答非所问', '信息过时', '看不懂', '其他'],
      selectedReason: '',
      text: '',
      doneText: '感谢反馈'
    }
  },
  methods: {
    buildReason() {
      const parts = []
      if (this.selectedReason) parts.push(this.selectedReason)
      const extra = (this.text || '').trim()
      if (extra) parts.push(extra)
      return parts.join(' ')
    },
    canSubmit() {
      if (!this.askRecordId) {
        this.$message.warning('问答记录尚未就绪，请稍后再试')
        return false
      }
      return true
    },
    async like() {
      if (!this.canSubmit()) return
      await feedbackApi.submit({
        type: 'like',
        question: this.question,
        askRecordId: this.askRecordId,
        conversationId: this.conversationId,
        reason: ''
      })
      this.doneText = '感谢反馈'
      this.state = 'done'
    },
    async submit() {
      if (!this.canSubmit()) return
      const reason = this.buildReason()
      if (!reason) {
        this.$message.warning('请选择原因或填写说明')
        return
      }
      await feedbackApi.submit({
        type: 'dislike',
        question: this.question,
        askRecordId: this.askRecordId,
        conversationId: this.conversationId,
        reason
      })
      this.doneText = '感谢反馈，我们会持续优化'
      this.state = 'done'
      this.$message.success('反馈已提交')
    },
    async skip() {
      if (!this.canSubmit()) return
      await feedbackApi.submit({
        type: 'dislike',
        question: this.question,
        askRecordId: this.askRecordId,
        conversationId: this.conversationId,
        reason: '(用户跳过)'
      })
      this.doneText = '已记录'
      this.state = 'done'
    }
  }
}
</script>

<style scoped>
.feedback-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
</style>
